import React, { useState } from 'react';

import { forceReloadEvent } from '@hooks/API/Event/UseEvent';
import { forceReloadProjectTimeline } from '@hooks/API/Project/UseProjectTimeline';

import AddEventDate from '@components/EventDrawer/BookingEvent/AddEventDate/AddEventDate';
import BookingEventCustomFields from '@components/EventDrawer/BookingEvent/BookingEventCustomFields';
import EditModelDatesForm from '@components/EventDrawer/BookingEvent/EditForms/EditModelDatesForm';
import MoveOrRemoveEventDate from '@components/EventDrawer/BookingEvent/EditForms/MoveOrRemoveEventDate';
import EventInfoEditForm from '@components/EventDrawer/BookingEvent/EventInfoEditForm';
import NwDrawer from '@components/Gui/NwDrawer';
import ObjectLogHistories from '@components/ObjectLogHistories/ObjectLogHistories';

import { editDrawerTypes, getEditDrawerTitle } from './bookingEventDetailsUtils';

const BookingEventDrawers = ({
    eventData,
    afterUpdate,
    editDrawerType,
    onCloseDrawers,
    customFields,
    selectedWorkingDate,
    selectedWorkingDay,
}) => {
    const [touchForm, setTouchForm] = useState(false);

    const handleUpdateEvent = async () => {
        onCloseDrawers();
        await forceReloadEvent(eventData.ID);
        await forceReloadProjectTimeline(eventData.Project.ID);
        await afterUpdate();
    };

    return (
        <NwDrawer
            width="45rem"
            minWidth="45rem"
            touchForm={touchForm}
            onTouchForm={setTouchForm}
            title={getEditDrawerTitle(editDrawerType)}
            onClose={onCloseDrawers}
            className="event-edit-drawers"
        >
            {editDrawerType === editDrawerTypes.editGeneralDetails && (
                <EventInfoEditForm
                    event={eventData}
                    customFields={customFields}
                    onCancel={onCloseDrawers}
                    onTouchForm={setTouchForm}
                    onUpdate={handleUpdateEvent}
                />
            )}
            {editDrawerType === editDrawerTypes.editCustomFields && (
                <BookingEventCustomFields
                    event={eventData}
                    customFields={customFields}
                    onTouchForm={setTouchForm}
                    onClose={onCloseDrawers}
                />
            )}
            {editDrawerType === editDrawerTypes.addDates && (
                <AddEventDate
                    event={eventData}
                    onSave={handleUpdateEvent}
                    onCancel={onCloseDrawers}
                    onTouchForm={setTouchForm}
                />
            )}
            {editDrawerType === editDrawerTypes.history && <ObjectLogHistories objectId={eventData.ID} type="Event" />}
            {editDrawerType === editDrawerTypes.editDates && selectedWorkingDate && (
                <EditModelDatesForm
                    date={selectedWorkingDate}
                    eventData={eventData}
                    onSave={handleUpdateEvent}
                    onClose={onCloseDrawers}
                    onTouchForm={setTouchForm}
                />
            )}
            {editDrawerType === editDrawerTypes.editWorkingDay && selectedWorkingDay && (
                <MoveOrRemoveEventDate
                    date={selectedWorkingDay}
                    eventData={eventData}
                    onSave={handleUpdateEvent}
                    onClose={onCloseDrawers}
                    onTouchForm={setTouchForm}
                />
            )}
        </NwDrawer>
    );
};

export default BookingEventDrawers;
